import React, { Component } from 'react';

class ErrorPage extends Component {
    render(){
        return (
            <div>
                Oops! Something went wrong!
            </div>
        )
    }
}

export default ErrorPage;

